import { createGlobalStyle, css } from 'styled-components';
import media from 'styled-media-query';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Maison Neue';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('/fonts/MaisonNeueExt-Light.ttf'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }

  @font-face {
    font-family: 'Maison Neue';
    font-style: medium;
    font-weight: 400;
    font-display: swap;
    src: url('/fonts/MaisonNeueExt-Medium.ttf'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }

  @font-face {
    font-family: 'Maison Neue';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('/fonts/MaisonNeueExt-Bold.ttf'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }


  @font-face {
    font-family: 'Adobe Caslon';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('/fonts/ACaslonPro-Italic.otf'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #__next {
    height: 100%;
  }

  html {
    font-size: 62.5%;
  }

  ${({ theme }) => css`
    body {
      font-family: ${theme.font.family};
      font-size: ${theme.font.sizes.medium};
      .Toastify__toast-container {
        ${media.lessThan('small')`
          width: 100vw;

          display: flex;
          align-items: center;
          justify-content: center;

          margin-top: 2rem;
        `}
      }

      .Toastify__toast {
        width: 90%;

        border-radius: 5px;
      }
    }
  `}
`;

export default GlobalStyles;
